
import React, { useEffect, useState } from 'react';
import './App.css';
import { VoiceQcDashboard } from './features/voiceqc/VoiceQcDashboard';
import { AzureLoginPage } from './features/auth/AzureLoginPage';
import { TopBar } from './components/TopBar/TopBar';
import { persistence } from './utils/persistence';

const LOGIN_KEY = 'nebulaqc_user';
const EMAIL_KEY = 'nebulaqc_email';
const API_BASE_URL = import.meta.env.VITE_API_URL ?? '';

type ViewType = 'analyze' | 'records';

function App() {
  const [userName, setUserName] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [hydrated, setHydrated] = useState(false);
  const [currentView, setCurrentView] = useState<ViewType>('analyze');

  useEffect(() => {
    const load = async () => {
      try {
        const savedName = await persistence.getItem(LOGIN_KEY);
        const savedEmail = await persistence.getItem(EMAIL_KEY);
        if (savedName) {
          setUserName(savedName);
          setUserEmail(savedEmail || '');
        }
      } catch {
        // ignore storage errors in demo
      } finally {
        setHydrated(true);
      }
    };
    load();
  }, []);

  const handleLoginSuccess = async (name: string, email: string) => {
    setUserName(name);
    setUserEmail(email);
    try {
      await persistence.setItem(LOGIN_KEY, name);
      await persistence.setItem(EMAIL_KEY, email);
    } catch {
      // ignore
    }
  };

  const handleLogout = async () => {
    // 调用后端注销接口
    try {
      window.location.href = `${API_BASE_URL}/auth/logout`;
    } catch {
      // 如果后端注销失败，至少清除本地状态
      setUserName(null);
      setUserEmail(null);
      try {
        await persistence.removeItem(LOGIN_KEY);
        await persistence.removeItem(EMAIL_KEY);
      } catch {
        // ignore
      }
    }
  };

  const handleViewChange = (view: ViewType) => {
    setCurrentView(view);
  };

  if (!hydrated) {
    return (
      <div className="app-root app-root-loading">
        <div className="app-loading-orbit">
          <div className="app-loading-core" />
        </div>
        <div className="app-loading-text">TPCN GenAI Lab. 控制台加载中...</div>
      </div>
    );
  }

  if (!userName) {
    return <AzureLoginPage onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="app-shell">
      <TopBar 
        userName={userName} 
        onLogout={handleLogout}
        currentView={currentView}
        onViewChange={handleViewChange}
      />
      <div className="app-root">
        <VoiceQcDashboard currentView={currentView} />
      </div>
    </div>
  );
}

export default App;
